<template>
  <base-input input-type="tel"
              :label="label"
              :min="'0'"
              :value="formattedAmount"
              :error-message="errorMessage"
              :hint="hint"
              :readonly="readonly"
              :autofocus="autofocus"
              :placeholder="formattedPlaceholder"
              size="large"
              icon="₪"
              v-on="listeners"
              class="amount-input"
              @keypress="preventKeys"
              @input="onInputToNumber"
              @focus="onFocus">
  </base-input>
</template>

<script>

import _ from 'lodash';
import { formatAmount, unformatAmount } from '../utils/formatters';
import BaseInput from './Inputs/BaseInput.vue';

export default {
  name: 'AmountInput',
  components: { BaseInput },
  props: {
    value: {
      type: Number,
      required: false,
    },
    placeholder: {
      type: Number,
      required: false,
    },
    autofocus: {
      type: Boolean,
      default: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'סכום',
    },
    hint: {
      type: String,
      default: '',
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  computed: {
    listeners() {
      // eslint-disable-next-line no-unused-vars
      const { input, ...listeners } = this.$listeners;
      return listeners;
    },
    error() {
      return !!this.errorMessage;
    },
    formattedAmount() {
      if (!_.isNil(this.value)) {
        return formatAmount(_.round(this.value, 1));
      }
      return '';
    },
    formattedPlaceholder() {
      if (!_.isNil(this.placeholder)) {
        return formatAmount(_.round(this.placeholder, 1));
      }
      return '';
    },
  },
  methods: {
    preventKeys(event) {
      if (/\D/.test(event.key)) {
        return event.preventDefault();
      }
      return true;
    },

    onInputToNumber(value) {
      if (_.isNil(value) || value === '') {
        this.$emit('input', null);
        return;
      }

      const numberValue = Number(unformatAmount(value));
      this.$emit('input', numberValue);
    },

    onFocus(event) {
      event.target.select();
    },
  },
};
</script>
